module.exports = __webpack_public_path__ + "static/cdl_lrv_logo-e2038c817fd0d6c5fbe180fe7bfae3a9.png";